import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader, DataTable, StatusBadge, Sel, BranchSel, opts } from "@/components/kit";
import SessionSheet from "@/components/SessionSheet";
import { useApi, dt, dur, peso, label } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Sessions() {
  const { branch, setBranch, branchName } = useAuth();
  const [f, setF] = useState({ status: "open", q: "", payment_status: "" });
  const [sel, setSel] = useState(null);
  const { data, loading, reload } = useApi("/sessions", { ...f, branch_id: branch });
  return (
    <div className="fade-up">
      <PageHeader title="Parking Sessions" subtitle={`${data?.length ?? 0} session(s)`} testid="sessions-header">
        <div className="relative"><Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input data-testid="sessions-search" className="w-48 pl-8" placeholder="Plate / session / ticket" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} /></div>
        <Sel value={f.status} onChange={(v) => setF({ ...f, status: v })} testid="sessions-status-filter" allLabel="All statuses"
          options={[{ value: "open", label: "Open (inside)" }, ...opts(["active", "payment_pending", "paid", "exit_pending", "completed", "exception", "cancelled"])]} />
        <Sel value={f.payment_status} onChange={(v) => setF({ ...f, payment_status: v })} testid="sessions-payment-filter" allLabel="Any payment" options={opts(["unpaid", "paid", "refunded"])} />
        <BranchSel value={branch} onChange={setBranch} testid="sessions-branch" />
      </PageHeader>
      <DataTable testid="sessions-table" loading={loading} rows={data} onRowClick={(r) => setSel(r.id)} columns={[
        { key: "session_no", label: "Session", render: (r) => <span className="font-mono text-xs">{r.session_no}</span> },
        { key: "plate", label: "Plate", render: (r) => <span className="plate text-xs">{r.plate}</span> },
        { key: "branch", label: "Branch", render: (r) => branchName(r.branch_id) },
        { key: "vehicle_type", label: "Type", render: (r) => label(r.vehicle_type) },
        { key: "entry_time", label: "Entry", render: (r) => dt(r.entry_time) },
        { key: "dur", label: "Duration", render: (r) => <span className="font-mono">{dur(r.duration_min)}</span> },
        { key: "slot", label: "Zone / Slot", render: (r) => `${r.zone_name || "—"} / ${r.slot_code || "—"}` },
        { key: "amt", label: "Amount", render: (r) => <span className="font-mono">{peso(r.live_amount ?? r.final_amount ?? r.amount_due)}</span> },
        { key: "payment_status", label: "Payment", render: (r) => <StatusBadge status={r.payment_status} /> },
        { key: "status", label: "Status", render: (r) => <span className="flex gap-1"><StatusBadge status={r.status} />{(r.offline || r.exit_offline) && <StatusBadge status="offline" tone="amber" />}</span> },
      ]} />
      <SessionSheet id={sel} onClose={() => setSel(null)} onChanged={reload} />
    </div>
  );
}
